import { FaPhoneAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default  function CallandRegisterComponent(){
  const navigate=useNavigate()

    const closeMenu = () =>{
navigate("/form")
    window.scrollTo({top:0,behavior:"smooth"})
   } 
    return(<div className="bg-[#20b2aa] text-center m-auto p-4">
       <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-center">
   <a className="flex  font-roboto items-center justify-center gap-2 bg-[#20b2aa] capitalize text-white px-6 py-3 text-xl  font-bold hover:bg-black transition">  Learn. Lead. Achieve. Enroll at Rankridge Schools and give your child a world-class future  </a>     {/*  <a href="tel:+919959303873" className="flex items-center justify-center">
      <button className="flex text-xl font-roboto items-center justify-center gap-2 bg-[#20b2aa] text-black px-6 py-3 rounded-lg font-semibold hover:bg-gray-200 transition">
        <FaPhoneAlt />
        Call Now +91 99 59 303 873
      </button>
    </a> */}
    
              <button onClick={closeMenu} className="bg-green-900 text-white px-6 py-3 rounded-lg font-semibold hover:bg-green-800 transition">
              ENQUIRE NOW
              </button>
             
            </div>
    
    
    </div>)



}